module.exports = __webpack_public_path__ + "img/culture-reports.53ef3175.svg";